import * as React from "react";
import { Link } from "gatsby";
import { Helmet } from "react-helmet";
import { StaticImage } from "gatsby-plugin-image";
//
import { LayoutContainer } from "../LayoutContainer";
import { DownloadAppPopup } from "../DownloadAppPopup";
//
import { cl } from "../../helpers/general";
import { GRADIENT_1 } from "../../styles";
import { DownloadAppButton } from "./DownloadAppButton";

export const MENU = [
  {
    url: "/",
    name: "Home",
  },
  // {
  //   url: "/enquiry",
  //   name: "Enquiry",
  // },
  {
    url: "/events",
    name: "Events & Contests",
  },
  {
    url: "/careers",
    name: "Careers",
  },
  // {
  //   url: "/explore",
  //   name: "Explore",
  // },
  // {
  //   url: "/about",
  //   name: "About",
  // },
  {
    url: "/faq",
    name: "FAQ",
  },
];

interface Props {
  hasPageIntro?: boolean;
}

export const Header = (props: Props) => {
  const [isDownloadPopupOpen, setIsDownloadPopupOpen] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <Helmet>
        <title>Quizzario</title>
        {!props.hasPageIntro && <body className="mt-20" />}
      </Helmet>
      <DownloadAppPopup
        isOpen={isDownloadPopupOpen}
        onClose={setIsDownloadPopupOpen}
      />
      <StaticImage
        alt=""
        src="../../images/blur-background.png"
        className="fixed -z-20 blur-3xl scale-150 h-1/2 w-1/2"
      />
      {isMenuOpen && (
        <Helmet>
          <html className="overflow-hidden" />
        </Helmet>
      )}
      <div
        onClick={toggleMenu}
        className={cl(
          "fixed inset-0 z-50 transition-all backdrop-blur-3xl p-10",
          !isMenuOpen && "opacity-0 invisible"
        )}
      >
        <StaticImage src="../../images/logo.png" width={180} alt="quizzario" />
        <ul
          className={cl(
            "text-2xl mt-8 font-light transition-all",
            !isMenuOpen && "translate-x-3"
          )}
        >
          {MENU.map((item, index) => (
            <li key={index}>
              <Link
                className="py-4 block"
                to={item.url}
                activeClassName={cl(
                  GRADIENT_1,
                  "bg-clip-text text-transparent font-bold"
                )}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
        <DownloadAppButton onClick={setIsDownloadPopupOpen} className="bottom-10 absolute" />
      </div>
      <div className="fixed inset-x-0 top-0 overflow-hidden z-40 bg-opacity-60 backdrop-blur-3xl bg-black text-white">
        <LayoutContainer>
          <header className="flex items-center justify-between py-4">
            <Link to="/">
              <StaticImage
                src="../../images/logo.png"
                width={180}
                alt="quizzario"
              />
            </Link>
            <menu className="flex space-x-12">
              <ul className="hidden lg:flex items-center space-x-6 lg:space-x-12">
                {MENU.map((item, index) => (
                  <li key={index}>
                    <Link
                      to={item.url}
                      activeClassName={cl(
                        GRADIENT_1,
                        "bg-clip-text text-transparent"
                      )}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
              <button
                className="lg:hidden w-7"
                type="button"
                onClick={toggleMenu}
              >
                <StaticImage
                  alt=""
                  src="../../images/menu.png"
                  className="w-full"
                />
              </button>
              <DownloadAppButton onClick={setIsDownloadPopupOpen} className="hidden md:block" />
            </menu>
          </header>
        </LayoutContainer>
      </div>
    </>
  );
};
